<template>
	<div>
		<h1>Есть многое..., но такой страницы нет</h1>
		<hr>
		<div class="image">
			<img src="src/assets/music_instruments.jpg"/>
		</div>
		<h1>ERROR 404 Страница не найдена</h1>
		<router-link :to="{name: 'sound'}">Перейти на стартовую</router-link>
	</div>
</template>

<script>
	export default {
		
	}
</script>
 <style scoped>
 
 	

 </style>